<template>
    <router-view :key="$route.path" />
</template>

<script>
    export default {
        name: "app",
        data: function ()
        {
            return {
                update: false
            };
        },
    };
</script>
